<template>
  <div class="animated fadeIn scroll" :style="divstyle">
    <b-modal
      title="Errore durante il salvataggio"
      class="modal-danger"
      v-model="errShow"
      @ok="errShow=false"
      ok-variant="danger"
      :ok-only="true"
    >
      {{errMessage}}
      <!-- div slot="modal-cancel">CANCEL</div -->
    </b-modal>
    <InsModRel v-model="insdata" :show="insShow" />
    <div v-if="loading">
      <semipolar-spinner :animation-duration="2000" :size="65" color="#ff1d5e" />Loading...
    </div>
    <div v-if="!loading">
      <h1>
        Registro Modalità relazionali
        <span v-if="noprogsel">{{progsel.nome}}</span>
      </h1>
        <span v-if="!noprogsel">
          <hr />Progetto:
          <multiselect
            id="progettilist"
            v-model="progsel"
            :options="progetti"
            :multiple="false"
            :close-on-select="true"
            label="nome"
            track-by="progettoid"
            :disabled="noprogsel"
            @input="fprogsel"
          ></multiselect>
        </span>
      <span v-if="progsel && progsel.nomr">
        <h1>*** Funzione disabilitata per questo progetto ***</h1>
      </span>
      <span v-else>
        <br>
        <button @click="aggMedie" v-if="progsel.progettoid">Aggiorna Medie</button>
        <toggle-button
          v-if="doctut"
          :width="80"
          :value="tdocnotut"
          color="#82C7EB"
          :labels="{unchecked: 'Tutor', checked: 'Docente'}"
          @change="tdocnotut = !tdocnotut"
        />
        <table v-if="progsel.progettoid">
          <tr>
            <th>Corsisti</th>
            <th
              v-for="mese in mesi"
              :key="mese.n"
              :class="classmese(mese.n)"
              @click="viewmodrels(0, mese.n)"
            >{{mese.name}}</th>
            <th>Media Int.</th>
            <th>Media Fin.</th>
          </tr>
          <tr v-for="alunno in alunni" :key="alunno.alunnoid">
            <td class="nowrap">
              <div class="left">
                {{alunno.posizione}})
                {{alunno.cognome}}
                {{alunno.nome}}
              </div>
              <div class="right">
                <span style="clear:both;">
                {{media(alunno.alunnoid)}}<br>
                <peity
                  v-if="media(alunno.alunnoid)"
                  :type="'bar'"
                  :options="baropts()"
                  :data="bardata(alunno.alunnoid,0).toString()"
                  :key="`${alunno.alunnoid}_0}`"
                ></peity>
                </span>
              </div>
            </td>
            <td
              v-for="mese in mesi"
              :key="mese.n + '.' + alunno.alunnoid"
              @click.exact="addmodrels(alunno.alunnoid, mese.n)"
              @click.ctrl="viewmodrels(alunno.alunnoid, mese.n)"
              :class="votatoclass(alunno.alunnoid, mese.n)"
            >
              {{mediamese(alunno.alunnoid, mese.n)}}
              <peity
                _v-if="votatoboolean(alunno.alunnoid, mese.n)"
                :type="'bar'"
                :options="baropts()"
                :data="bardata(alunno.alunnoid,mese.n).toString()"
                :key="`${alunno.alunnoid}_${mese.n}`"
              ></peity>
            </td>
            <td>{{media1[alunno.alunnoid]}}</td>
            <td>{{media2[alunno.alunnoid]}}</td>
          </tr>
        </table>
        <hr />
      </span>
    </div>
  </div>
</template>
<script>
import { API } from "@/api.js";
import { SemipolarSpinner } from "epic-spinners";
import { DateTime } from "luxon";
import InsModRel from "./widgets/InsModRel";
import Peity from "vue-peity";
import { ToggleButton } from "vue-js-toggle-button";

export default {
  name: "dashboard",
  mixins: [window.myMixin],
  components: {
    SemipolarSpinner,
    InsModRel,
    Peity,
    ToggleButton
  },
  data: function() {
    return {
      doctut: false, // è entrambi, bisogna scegliere
      tdocnotut: false, // la scelta
      noprogsel: false,
      loading: false,
      errMessage: false,
      errShow: false,
      insShow: false,
      insdata: {},
      progsel: {},
      progetti: [],
      alunni: [],
      docs: [],
      votanti: [],
      barcache: {},
      medie: {},
      mediemese: {},
      voti: {},
      istut: false, // dice se l'utente corrente è tutor per questo progetto
      isdoc: false, // dice se l'utente corrente è docente per questo progetto
      media1: [],
      media2: [],
      mesi: [
        // { n: 9, name: "Settembre" },
        { n: 10, name: "Ottobre" },
        { n: 11, name: "Novembre" },
        { n: 12, name: "Dicembre" },
        { n: 1, name: "Gennaio" },
        { n: 2, name: "Febbraio" },
        { n: 3, name: "Marzo" },
        { n: 4, name: "Aprile" },
        { n: 5, name: "Maggio" },
        { n: 6, name: "Giugno" }
      ]
    };
  },
  props: ["noframe"],
  watch: {
    tdocnotut: function(n){
      this.isdoc = n
      this.istut = !n
    },
    insdata: async function(n, o) {
      this.insShow = n.show;
      console.log("watch...!", n);
      if (n && n.cancel == false) {
        console.log("SALVO...!");
        await API.sqlprep(this, "modrel.delvalut", [
          n.aid,
          n.mese,
          n.istut ? 0 : n.did
        ]);
        if (n.istut) {
          n.tutor.forEach(v => {
            API.sqlprep(this, "modrel.insvalut", [
              v.v.id,
              n.aid,
              n.mese,
              0,
              n.did
            ]);
          });
          this.votanti["v0_" + n.mese + "_" + n.aid] = true;
        }
        if (n.isdoc) {
          n.comp.forEach(v => {
            API.sqlprep(this, "modrel.insvalut", [
              v.v.id,
              n.aid,
              n.mese,
              n.did,
              n.did
            ]);
          });
          n.form.forEach(v => {
            API.sqlprep(this, "modrel.insvalut", [
              v.v.id,
              n.aid,
              n.mese,
              n.did,
              n.did
            ]);
          });
          this.votanti["v" + n.did + "_" + n.mese + "_" + n.aid] = true;
          this.$forceUpdate();
        }
      }
    }
  },
  filters: {
    itadata: function(value) {
      if (!value || value == "") return "";
      return value
        .split("-")
        .reverse()
        .join("/");
    }
  },
  computed: {
    divstyle: function() {
      return `height: calc(100vh - ${this.noframe ? 0 : 180}px);`;
    }
  },
  methods: {
    async aggMedie() {
      this.loading = true;
      await API.sqlprep(this, "modrel.refreshvotialunnomese", [ ]);
      await this.getMedieTot()
      this.loading = false;
    },
    async getMedieTot(){
      let media1 = []
      let media2 = []
      for(let alunno of this.alunni ) {
        media1[alunno.alunnoid] = 0
        for(let mese of [10,11,12,1]) {
          var als = await API.sqlprep(this, "modrel.votialunnomese", [
              alunno.alunnoid,mese
          ]);
          // console.log("???",alunno.alunnoid,mese,als.data)
          for(let r of als.data.dati)
            media1[alunno.alunnoid] += r.v*0.25 // media su 4 mesi
        }
        media2[alunno.alunnoid] = 0
        for(let mese of [2,3,4,5,6]) {
          var als = await API.sqlprep(this, "modrel.votialunnomese", [
              alunno.alunnoid,mese
          ]);
          for(let r of als.data.dati)
            media2[alunno.alunnoid] += r.v*0.20 // media su 5 mesi
        }
        media1[alunno.alunnoid] = Math.round(media1[alunno.alunnoid])
        media2[alunno.alunnoid] = Math.round(media2[alunno.alunnoid])
      }
      this.media1 = media1
      this.media2 = media2
    },
    media: function(aid) {
      return this.medie["a" + aid];
    },
    mediamese: function(aid, mese) {
      return this.mediemese["a" + aid + "-" + mese];
    },
    testmese(mese){
      var cm = new Date().getMonth() + 1
      var tmese = mese < 9 ? mese + 12 : mese;
      var tcm = cm < 9 ? cm + 12 : cm;
      return !(tmese > tcm)
    },
    classmese: function(mese) {
      if(!this.testmese(mese)) return "w70p rot90 mesi";
      else return "w70p clickme rot90 mesi";
    },
    votatoboolean: function(aid, mese) {
      if(!this.testmese(mese)) return false;

      var did = this.getUserID();
      if (this.istut)
        return !this.votanti["v0_" + mese + "_" + aid] ? false : true;
      if (this.isdoc)
        return !this.votanti["v" + did + "_" + mese + "_" + aid] ? false : true;
      var ndocs = this.docs.length;
      if (!this.votanti["n" + mese + "_" + aid]) return false;
      if (this.votanti["n" + mese + "_" + aid] < ndocs) return false;
      return true;
    },
    votatoclass: function(aid, mese) {
      if(!this.testmese(mese)) return "w70p";

      var did = this.getUserID();
      if (this.istut)
        return (
          "w70p clickme " +
          (!this.votanti["v0_" + mese + "_" + aid] ? "novoto" : "voto")
        );
      if (this.isdoc)
        return (
          "w70p clickme " +
          (!this.votanti["v" + did + "_" + mese + "_" + aid]
            ? "novoto"
            : "voto")
        );
      var ndocs = this.docs.length;
      if (!this.votanti["n" + mese + "_" + aid]) return "clickme novoto w70p";
      if (this.votanti["n" + mese + "_" + aid] < ndocs)
        return "clickme novoto w70p";
      return "clickme voto w70p";
    },
    viewmodrels: function(aid, mese) {
      if (this.getUserLIV < 5) return;
      this.addmodrels(aid, mese);
      // forzo la modalità supervisore
      this.insdata.istut = false;
      this.insdata.isdoc = false;
      this.insShow = true;
    },
    addmodrels: function(aid, mese) {
      if(!this.testmese(mese)) return;

      var did = this.getUserID();
      this.insdata = {
        pid: this.progsel.progettoid,
        did: did,
        aid: aid,
        istut: this.istut,
        isdoc: this.isdoc,
        mese: mese,
        show: true,
        cancel: true
      };
      console.log("INS...", did, this.insdata);
      if (this.istut || this.isdoc) this.insShow = true;
    },
    testErr: function(ret) {
      console.log("testErr", ret);
      if (ret.data.errInfo[2] !== null || ret.data.cerrInfo[2] !== null) {
        this.errMessage =
          (ret.data.errInfo[2] || "") + (ret.data.cerrInfo[2] || "");
        this.errShow = true;
        return true;
      } else {
        return false;
      }
    },
    fprogsel: async function() {
      //this.$nextTick(async () => {
      this.loading = true;
      var did = this.getUserID();

      // medie
      var tmp = await API.sqlprep(this, "modrel.totvoti", [
        this.progsel.progettoid
      ]);
      var medie = {};
      tmp.data.dati.map(d => {
        medie["a" + d.alunnoid] = d.media;
      });
      this.medie = medie;

      // mediemese
      tmp = await API.sqlprep(this, "modrel.totvotimese", [
        this.progsel.progettoid
      ]);
      var mediemese = {};
      tmp.data.dati.map(d => {
        mediemese["a" + d.alunnoid + "-" + d.mese] = d.media;
      });
      this.mediemese = mediemese;

      // voti
      tmp = await API.sqlprep(this, "modrel.voti", [
        this.progsel.progettoid
      ]);
      var voti = {};
      tmp.data.dati.map(d => {
        voti["a" + d.alunnoid + "-" + d.mese + "-" + d.gruppo] = d.v;
      });
      this.voti = voti;
      console.log("VOTI:", voti);

      // elenco alunni
      var als = await API.sqlprep(this, "registro.selals", [
        this.progsel.progettoid
      ]);
      var als2 = await API.sqlprep(this, "registro.selalsappr", [
        this.progsel.progettoid,
        this.progsel.progettoid
      ]);
      var alunni = als.data.dati
        .map(m => ({
          alunnoid: m.alunnoid,
          nome: m.nome,
          cognome: m.cognome,
          posizione: m.posizione || 0
        }))
        .sort((a, b) => {
          return a.posizione - b.posizione;
        });
      var alunni2 = als2.data.dati
        .map(m => ({
          alunnoid: m.alunnoid,
          nome: m.nome,
          cognome: m.cognome,
          posizione: "APPR"
        }))
        .sort((a, b) => {
          if (a.cognome < b.cognome) return -1;
          else if (a.cognome > b.cognome) return 1;
          else return 0;
        });
      alunni = alunni.concat(alunni2);

      var alids = alunni.map(a => a.alunnoid).join();

      var docs = await API.sqlprep(this, "modrel.docincs", [
        ORE_THRESHOLD,
        this.progsel.progettoid,
        this.progsel.progettoid,
        this.progsel.progettoid
      ]);

      var tmp = await API.sqlprep(this, "modrel.votanti", [], {
        "@alids": alids
      });
      var votanti = {};
      tmp.data.dati.map(v => {
        votanti["v" + v.docid + "_" + v.mese + "_" + v.alunnoid] = true;
        votanti["n" + v.mese + "_" + v.alunnoid] = 0;
      });
      tmp.data.dati.map(v => {
        votanti["n" + v.mese + "_" + v.alunnoid]++;
      });
      console.log("VOTANTI:", votanti, docs);

      var istut = docs.data.dati.find(d => d.doc == 0 && d.docenteid == did) ? true : false;
      var isdoc = docs.data.dati.find(d => d.doc == 1 && d.docenteid == did) ? true : false;

      this.doctut = istut && isdoc
      this.tdocnotut = !istut 
      this.isdoc = istut ? false : isdoc
      this.istut = istut && !this.isdoc
      //console.log("??",isdoc,istut,this.isdoc,this.istut)
      this.docs = docs.data.dati;
      this.alunni = alunni;
      this.votanti = votanti;

      await this.getMedieTot()

      this.loading = false;
    },
    bardata: function(aid, mese) {
      if (this.barcache[aid + "_" + mese])
        return this.barcache[aid + "_" + mese];

      var grps = [
        "Atteggiamento",
        "Partecipazione",
        "Consegne",
        "Materiale",
        "Regolamento"
      ];
      var divs = [12.0, 24.0, 10.0, 20.0, 34.0];
      var ret = [0, 0, 0, 0, 0];
      if (mese > 0) {
        grps.forEach((g, i) => {
          ret[i] =
            ( (this.voti["a" + aid + "-" + mese + "-" + g] || 0)/ divs[i]) * 100;
        });
      } else {
        let mk = 0;
        this.mesi.forEach(m => {
          grps.forEach((g, i) => {
            if (this.voti["a" + aid + "-" + m.n + "-" + g] > 0) {
              ret[i] +=
                (this.voti["a" + aid + "-" + m.n + "-" + g] / divs[i]) * 100;
              mk++;
            }
          });
        });
        console.log("RET1", ret, mk);
        ret = ret.map(r => (r * 5) / mk); // mk viene incrementato 5 volte per ogni voto
        console.log("RET2", ret);
      }
      this.barcache[aid + "_" + mese] = ret;
      // console.log("RET3", aid,ret);
      return ret;
    },
    baropts: function() {
      return {
        fill: ["red", "white", "blue", "orange", "yellow"],
        width: 50,
        height: 25,
        max: 100
      };
    }
  },
  mounted: async function() {
    var url = new URL(window.location.href);
    var progettoid = url.searchParams.get("progettoid");

    var token = this.getTokenData().sub;
    var prgs;
    var sql;
    if (this.getUserLIV() >= 5)
      prgs = await API.sqlprep(this, "registro.selprog", []);
    else
      prgs = await API.sqlprep(this, "registro.selprogsede", [
        token.user.sedeid
      ]);

    this.progetti = prgs.data.dati
      .map(p => ({
        progettoid: p.progettoid,
        annualita: p.annualita,
        nome: p.numero + " - " + p.nome,
        nomr: p.nomodrel,
      }))
      .sort((a, b) => {
        if (a.nome < b.nome) return -1;
        else if (a.nome > b.nome) return 1;
        else return 0;
      });

    var dtmp = await API.sqlprep(this, "registro.seldocs", []);
    var docs = [];
    dtmp.data.dati.map(d => {
      docs[d.docenteid] = d.nome;
    });
    this.docs = docs;

    if (progettoid) {
      this.progsel = this.progetti.find(p => p.progettoid == progettoid);
      this.noprogsel = true;
      this.fprogsel();
    }
  }
};
</script>
<style scoped>
table tr {
  height: 40px;
}
td.novoto {
  background-color: darkcyan;
}
td.voto {
  background-color: green;
}
.left {
  float: left;
}
.right {
  float: right;
}
th.mesi {
  text-align: center;
}
th.rot90 {
  /* height: 200px;
  transform: rotate(-90deg) translateY(20px);
  transform-origin: left bottom 0; 
  min-width: 195px;*/
}
th.rot90 span {
  font-weight: normal;
}
td {
  vertical-align: top;
  border: 1px solid black;
  padding: 10px;
}
th {
  vertical-align: bottom;
}
div.scroll {
  overflow: scroll;
}
.w100 {
  width: 100%;
}
.w70p {
  width: 70px;
}
td.nowrap {
  white-space: nowrap;
  position: relative;
  vertical-align: top;
}
.clickme {
  cursor: pointer;
}
</style>
<style>
td.nowrap .vdatetime-popup {
  white-space: initial !important;
}
div.registro input.vdatetime-input {
  width: 100%;
}
</style>